import classNames from 'classnames';
import { ReactNode } from 'react';
import Tooltip from '../Tooltip';

export type FormTypography = 'default' | 'comfortable';

interface FormLabelProps {
  label?: string;
  tooltip?: ReactNode;
  required?: boolean;
  htmlFor?: string;
  id?: string;
  typography?: FormTypography;
}

export const FormLabel = ({
  label,
  tooltip,
  required,
  htmlFor,
  id,
  typography = 'default',
}: FormLabelProps) => {
  if (!label && !tooltip) return null;
  return (
    <span className="flex min-w-0 items-center">
      <span className="flex items-center">
        {label && (
          <label
            id={id}
            htmlFor={htmlFor}
            // `relative` contains the sr-only marker; otherwise it resolves
            // against a distant scroller and stretches the page (MCV-1706).
            className={classNames(
              'relative text-left text-content-primary',
              typography === 'comfortable' ? 'text-sm font-semibold leading-normal' : 'body-text-sb'
            )}
          >
            {label}
            {required && (
              <>
                {/* [MCV-1234, MCV-1239, MCV-1247, MCV-1249] Asterisks inherit the
                    label color (dark) instead of error red, matching inline-`*`
                    labels used elsewhere in the same forms. The asterisk is a
                    required-field marker, not an error state. */}
                <span className="pl-px text-content-primary" aria-hidden="true">
                  *
                </span>
                <span className="sr-only">(required)</span>
              </>
            )}
          </label>
        )}
        {tooltip && <Tooltip content={tooltip} />}
      </span>
    </span>
  );
};
